import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React from 'react';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  },
}));

const ResponsiveTableContainer = ({ children }) => (
    <div style={{ overflowX: 'auto', width: '100%' }}>
        {children}
    </div>
);

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const EnvironmentTable = () => (
  <ResponsiveTableContainer>
  <Table sx={{ minWidth: 600 }} aria-label="environment table">
    <TableHead>
      <TableRow>
        <StyledTableCell style={{ fontSize: 16 }}>Name</StyledTableCell>
        <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
        <StyledTableCell style={{ fontSize: 16 }}>Type</StyledTableCell>
        <StyledTableCell style={{ fontSize: 16 }}>Test Value</StyledTableCell>
        <StyledTableCell style={{ fontSize: 16 }}>Required</StyledTableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      <StyledTableRow key="username">
        <StyledTableCell>username</StyledTableCell>
        <StyledTableCell>Customer Number</StyledTableCell>
        <StyledTableCell>string</StyledTableCell>
        <StyledTableCell>Individual customer: 1, 2, 3, 4, 5, 6, 7<br/>Corporate customer: 12</StyledTableCell>
        <StyledTableCell>true</StyledTableCell>
      </StyledTableRow>
      <StyledTableRow key="Password">
        <StyledTableCell>password</StyledTableCell>
        <StyledTableCell>Customer Login Number</StyledTableCell>
        <StyledTableCell>string</StyledTableCell>
        <StyledTableCell>123456</StyledTableCell>
        <StyledTableCell>true</StyledTableCell>
      </StyledTableRow>
      <StyledTableRow key="Corporate Username">
        <StyledTableCell>corporateUsername</StyledTableCell>
        <StyledTableCell>
          User code given to your company's authorized officers.<br/>
          It should only be used for corporate accounts.
        </StyledTableCell>
        <StyledTableCell>string</StyledTableCell>
        <StyledTableCell>testUser1</StyledTableCell>
        <StyledTableCell>true</StyledTableCell>
      </StyledTableRow>
    </TableBody>
  </Table>
  </ResponsiveTableContainer>
);

export default EnvironmentTable;
